"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _commonReact = require("@devsta/common-react");

var _SubscriptionBlockContent = _interopRequireDefault(require("./SubscriptionBlockContent"));

require("../styles/_subscription-block.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function SubscriptionBlock(_ref) {
  var title = _ref.title,
      defaultImage = _ref.defaultImage,
      assignmentType = _ref.assignmentType,
      assignedDescriptions = _ref.assignedDescriptions,
      image = _ref.image,
      assignedName = _ref.assignedName,
      assignmentModalContent = _ref.assignmentModalContent,
      onSave = _ref.onSave,
      onToggleModal = _ref.onToggleModal,
      saveBtnText = _ref.saveBtnText,
      closeBtnText = _ref.closeBtnText,
      onCloseModal = _ref.onCloseModal,
      customModalTitle = _ref.customModalTitle,
      onBackClick = _ref.onBackClick,
      stayOpenOnSave = _ref.stayOpenOnSave,
      modalSaveDisabled = _ref.modalSaveDisabled,
      className = _ref.className,
      imageIsIcon = _ref.imageIsIcon,
      id = _ref.id,
      disabled = _ref.disabled;
  return _react.default.createElement(_commonReact.Form.TitledFormBlock, {
    id: id,
    title: title,
    defaultImage: defaultImage,
    itemImage: image,
    imagePlaceholder: imageIsIcon ? void 0 : assignedName,
    className: (0, _classnames.default)('subscription-block', className),
    hasSelectedItem: Boolean(assignedName)
  }, _react.default.createElement(_SubscriptionBlockContent.default, {
    assignmentType: assignmentType,
    assignedDescriptions: assignedDescriptions,
    assignedName: assignedName,
    image: image,
    onSave: onSave,
    onToggleModal: onToggleModal,
    saveBtnText: saveBtnText,
    closeBtnText: closeBtnText,
    onCloseModal: onCloseModal,
    onBackClick: onBackClick,
    stayOpenOnSave: stayOpenOnSave,
    assignmentModalContent: assignmentModalContent,
    modalSaveDisabled: modalSaveDisabled,
    customModalTitle: customModalTitle,
    disabled: disabled
  }));
}

var _default = (0, _react.memo)(SubscriptionBlock);

exports.default = _default;